<template>
  <div v-if="loading">
    <oil-cap
        :title="'водители'.toUpperCase()"
        :buttons="[
                  {
                    route: 'driver',
                    name: 'добавить водителя'.toUpperCase()
                  }
        ]"
    />
    <v-divider class="mt-2 mb-2"/>
    <oil-table
        :items="drivers"
        :keys="[
          {text:'ФИО',value:'Name'},
          {text:'Автомобиль',value:'VehicleModel'},
          {text:'Зарплата',value:'Salary'},
          {text:'Стаж',value:'Experience'},
          {text:'Статус',value:'Status'},
          {text:'',value:'Id'}
      ]"
    >
      <template v-slot:Id="{value}">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-bind="attrs"
                   v-on="on" icon
                   @click.stop="rowClick(value)">
              <v-icon color="primary">
                mdi-pen
              </v-icon>
            </v-btn>
          </template>
          <span>РЕДАКТИ́РОВАТЬ</span>
        </v-tooltip>
      </template>
      <template v-slot:Status="{value}">
        <v-chip :color="status[value].color">
          {{ status[value].value }}
        </v-chip>
      </template>
    </oil-table>
  </div>

</template>

<script>
import {driverService} from "@/services/DriverSerivce";

export default {
  data: () => ({
    loading: false,
    drivers: [],
    status: {
      active: {value: 'Активный', color: 'green'},
      inactive: {value: 'Неактивный', color: 'red'},
    }
  }),
  components: {
    OilTable: () => import('@/components/helper/oil.table'),
    OilCap: () => import('@/components/helper/oil.cap'),
  },
  async created() {
    const drivers = await driverService.getAll()
    this.drivers = drivers.data
    this.loading = true
  },
  methods: {
    rowClick(Id) {
      this.$router.push(`/driver/${Id}`)
    }
  }
}
</script>
